import React, { useEffect, useState } from 'react';
import { translate } from '../Services/translation';

interface SkipLink {
  id: string;
  text: string;
  href: string;
}

const SkipLinks = () => {
  const [skipLinkList, setSkipLinkList] = useState<SkipLink[]>([]);

  useEffect(() => {
    const updateSkipLinks = () => {
      const links: SkipLink[] = [];

      if (document.getElementById('mainContent')) {
        links.push({
          id: 'skip-to-content',
          text: translate('skip-link.skip-to-main-content'),
          href: '#mainContent',
        });
      }

      const productListing = document.getElementById(
        'productListingAnchor'
      );
      if (productListing) {
        links.push({
          id: 'skip-to-product-listing',
          text: translate('skip-link.skip-to-product-listing'),
          href: '#productListingAnchor',
        });
      }

      setSkipLinkList(links);

      return !!productListing;
    };

    const productListingFound = updateSkipLinks();

    if (productListingFound) {
      return;
    }

    const observer = new MutationObserver(() => {
      const productListingFound = updateSkipLinks();

      if (productListingFound) {
        observer.disconnect();
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <>
      {skipLinkList.length > 0 && (
        <div className="pointer-events-none fixed -left-40 top-4 z-[100] rounded border border-gray-300 bg-white p-4 opacity-0 focus-within:pointer-events-auto focus-within:left-4 focus-within:opacity-100">
          <ul>
            {skipLinkList.map((link) => (
              <li key={link.id} className="mb-2">
                <a
                  href={link.href}
                  className="border-b text-gray-900 last-of-type:border-b-0 hover:underline"
                >
                  {link.text}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </>
  );
};

export default SkipLinks;
